/* eslint-disable */
import React from 'react';

const CommentsIcon = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} >
    <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V15C20 15.5523 19.5523 16 19 16H12.4948C12.2478 16 12.0095 16.0914 11.8259 16.2567L7.66667 20V17C7.66667 16.4477 7.21895 16 6.66667 16H5C4.44772 16 4 15.5523 4 15V5Z" stroke="#212121" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);

export {CommentsIcon};
